import type { OrderActivityCreateSalesOrderConfirmationSchemaType } from "~/modules/orders/schema";

/** Custom templates ignore built-in edits; keep the draft intact for switching back. */
export const toOptInOrderDocumentCreateInput = <TValues>(draft: TValues, prefill: TValues, useOutputTemplate: boolean): TValues =>
  useOutputTemplate ? prefill : draft;

/** Only activity metadata reaches the custom confirmation renderer. */
export const toSalesOrderConfirmationCreateInput = (
  values: OrderActivityCreateSalesOrderConfirmationSchemaType,
): OrderActivityCreateSalesOrderConfirmationSchemaType => {
  if (!values.useOutputTemplate) {
    return values;
  }
  return {
    orderId: values.orderId,
    action: values.action,
    comment: values.comment,
    useOutputTemplate: true,
  };
};
